<template>
  <div class="h-100">
    <div id="input" class="mb-2">
      <b-row>
        <b-col cols="8">
          <div class="SearchBar">
            <b-icon-search class="SearchIcon"></b-icon-search>
            <b-form-input
              v-model="filter"
              type="search"
              id="SearchInput"
              placeholder="Type to Search"
              class="mr-2"
            ></b-form-input>
          </div>
        </b-col>
        <b-col class="my-auto">
          <b-form-checkbox
            id="checkboxLowConfidence"
            v-model="showLowConfidence"
            name="checkbox"
            class=""
          >
            Include items with low confidence
          </b-form-checkbox>
        </b-col>
      </b-row>
    </div>
    <b-table
      :items="tableItems"
      :fields="fields"
      :sort-desc="true"
      sort-by="mean"
      striped
      dark
      sticky-header="85vh"
      no-border-collapse
      :busy="isBusy"
      ref="my-table"
      :stacked="stacked"
      class="test-table"
    >
      <template v-slot:cell(icon)="data">
        <div
          id="rowItemIcon"
          v-bind:style="{ backgroundImage: `url('${data.item.icon}')` }"
        ></div>
      </template>

      <template v-slot:cell(name)="data">
        <template v-if="data.item.lowConfidence">
          <span style="color: #e57373">{{ data.item.name }}</span>
        </template>
        <template v-else>{{ data.item.name }}</template>
      </template>

      <template v-slot:cell(divine)="data">
        {{ data.item.divine }}
        <b-img
          src="https://web.poecdn.com/gen/image/WzI1LDE0LHsiZiI6IjJESXRlbXMvQ3VycmVuY3kvQ3VycmVuY3lNb2RWYWx1ZXMiLCJ3IjoxLCJoIjoxLCJzY2FsZSI6MX1d/e1a54ff97d/CurrencyModValues.png"
          height="32"
          class="mx-1"
        ></b-img>
      </template>

      <template v-slot:cell(mean)="data">
        {{ data.item.mean }}
        <b-img
          src="https://web.poecdn.com/image/Art/2DItems/Currency/CurrencyRerollRare.png?v=c60aa876dd6bab31174df91b1da1b4f9"
          height="32"
          width="28"
          class="mr-1"
        ></b-img>
        <b-button
          size="sm"
          variant="outline-success"
          :href="getHref(data.item)"
          target="_blank"
        >
          <b-icon-search></b-icon-search>
        </b-button>
      </template>

      <template v-slot:cell(change)="{ value, item }">
        <template v-if="value > 0">
          <span style="color: green">+{{ value }}%</span>
        </template>
        <template v-else>
          <span style="color: red">{{ value }}%</span>
        </template>
        <b-button
          id="show-btn"
          @click="detailedForward(item)"
          size="sm"
          variant="outline-warning"
          class="ml-2"
        >
          <b-icon-hourglass></b-icon-hourglass>
        </b-button>
      </template>

      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
    <b-button :disabled="isBusy" v-if="showButton" @click="inc"
      >More ...</b-button
    >
  </div>
</template>

<script>
import { getItems } from "../shared/getItems";
export default {
  data() {
    return {
      loaded: false,
      chartdata: [],
      tableItems: [],
      currentPage: 1,
      fetchedItems: [],
      isBusy: true,
      filter: "",
      perPage: 40,
      conf: false,
      showLowConfidence: false,
      offset: 0,
      buttonText: "Show items with low confidence",
      stacked: false,
      showButton: false,
    };
  },
  props: ["items", "fields", "league", "getHref", "category", "smallScreen"],
  mounted: async function() {
    if (this.smallScreen) {
      this.stacked = "md";
      this.showButton = true;
    } else {
      this.stacked = false;
      this.showButton = false;
    }

    this.fetchedItems = await getItems(this.category, this.league);
    this.tempItems = this.fetchedItems;
    this.tableItems = this.fetchItems();
    this.isBusy = false;

    const tableScrollBody = this.$refs["my-table"].$el;
    /* Consider debouncing the event call */
    tableScrollBody.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    /* Clean up just to be sure */
    const tableScrollBody = this.$refs["my-table"].$el;
    tableScrollBody.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    fetchItems() {
      let items = [];
      let counter = 0;

      while (
        this.offset + counter < this.fetchedItems.length &&
        items.length < this.perPage
      ) {
        let item = this.fetchedItems[this.offset];

        if (this.matchesFilter(item)) {
          items.push(item);
        }
        //items.push(item)
        this.offset++;
      }
      this.offset += counter;

      return items;
    },
    matchesFilter(item) {
      if (this.filter != "") {
        if (!item.name.toLowerCase().includes(this.filter.toLowerCase())) {
          return false;
        }
      }

      if (item.lowConfidence && !this.showLowConfidence) {
        return false;
      }

      return true;
    },
    detailedForward(item) {
      this.$router.push({ path: "/detailed/" + item.id });
    },
    inc() {
      if (!this.isBusy) {
        let fetch = this.fetchItems();
        if (fetch.length == 0) {
          this.showButton = false;
        }
        this.tableItems = this.tableItems.concat(fetch);
      }
    },
    onScroll(event) {
      if (
        event.target.scrollTop + event.target.clientHeight ==
        event.target.scrollHeight
      ) {
        if (!this.isBusy) {
          let fetch = this.fetchItems();
          this.tableItems = this.tableItems.concat(fetch);
        }
      }
    },
  },
  watch: {
    isBusy(newVal, oldVal) {
      if (newVal !== oldVal) {
        const tableScrollBody = this.$refs["my-table"].$el;
        if (newVal === true) {
          tableScrollBody.classList.add("overflow-hidden");
        } else {
          tableScrollBody.classList.remove("overflow-hidden");
        }
      }
    },
    filter() {
      this.offset = 0;
      this.tableItems = this.fetchItems();
    },
    showLowConfidence() {
      this.currentPage = 1;
      this.offset = 0;
      this.tableItems = this.fetchItems();
    },
    smallScreen() {
      if (this.smallScreen) {
        this.stacked = "md";
        this.showButton = true;
      } else {
        this.stacked = false;
        this.showButton = false;
      }
    },
  },
};
</script>

<style>
.table td {
  font-size: 1.1em;
}

.table th {
  font-size: 1.2em;
}
#input {
  color: white;
}
.input-group-text {
  background-color: #22262b;
  border-color: transparent;
}
#checkboxLowConfidence {
  color: #22262b;
  border-color: transparent;
}

#rowItemIcon {
  background-size: contain;
  height: 32px;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
